import mixpanel from '@disco/api/mixpanel'

import React from 'react'
import { useDispatch } from 'hooks/use-redux'
import { useNavigate } from 'react-router-dom'
import Button from 'components/ui/button'

const HeaderInviteLinkButton = (): React.ReactNode => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const handleOnClick = () => {
    navigate('/settings/users/invites')
    mixpanel.sendPureEvent('Click button', {
      Context: 'Invite new user',
      Location: 'Explorer',
      Copy: '+ Invite',
    })
  }

  return <Button icon="invite" onClick={handleOnClick} caption="Invite" />
}

export default HeaderInviteLinkButton
